import React, { useState, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import Axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';

import ProjectCard from '../../components/ProjectCard';
import SNSPanel from '../../components/SNSPanel';
import './index.scss';

let axiosCache = {};

const AxiosWithCache = (url) => {
    if (!axiosCache[url]) {
        axiosCache[url] = Axios.get(url);
    }
    return axiosCache[url];
}

const ProjectList = ({ wording }) => {
  const autoload = useRef(null);
  const [project, setProject] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [category, setCategory] = useState(null);
  const [loadIndex, setLoadIndex] = useState(0);
  const [loadingAnimation, setLoadingAnimation] = useState(false);
  const [pageData, setPageData] = useState(null);
  const { search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    getProject(loadIndex);
    getCategory();
    window.addEventListener('scroll', handleWatchScroll);
    return () => {
      window.removeEventListener('scroll', handleWatchScroll);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const category = params.get('category');
    setCurrentCategory(category);
  }, [])

  useEffect(() => {
    getProject(1);
  }, [currentCategory]);

  const getProject = (page) => {
    const params = `${currentCategory ? `&category=${currentCategory}` : ''}`;
    AxiosWithCache(`/api/project-list?page=${page}${params}`)
      .then(res => {
        const { data, last_page, current_page } = res.data;
        setLoadIndex(1);
        autoload.current.dataset.index = 1;
        setProject(data);
        setPageData({ all: last_page, current: current_page });
      });
  };

  const updateProject = (page) => {
    const params = `${currentCategory ? `&category=${currentCategory}` : ''}`;

    if (pageData && pageData.all >= page) {
      setLoadingAnimation(true);
      setTimeout(() => {
        AxiosWithCache(`/api/project-list?page=${page}${params}`)
          .then(res => {
            const { data } = res.data;
            setProject(project.concat(data));
            setLoadingAnimation(false);
            autoload.current.dataset.index = page;
          });
      }, 500);
    }
  }

  useEffect(() => {
    loadIndex !== 1 &&
      updateProject(loadIndex);
  }, [loadIndex]);

  const handleWatchScroll = () => {
    if (window.scrollY + window.innerHeight > autoload.current.offsetTop) {
      setLoadIndex(Number(autoload.current.dataset.index) + 1);
    }
  }

  const getCategory = () => {
    AxiosWithCache(`/api/project-category`).then(res => setCategory(res.data));
  };

  function handleCategoryClick(slug) {
    setCurrentCategory(slug);
    if (slug) {
        history.replace({
            search: `?category=${slug}`
        });
    }
    else {
        history.replace({
            search: ''
        });
    }
  }

  const _w = wording;
  return (
    <React.Fragment>
      <Helmet>
        <title>{_w.meta_title}</title>
      </Helmet>
      <div className="project-page">
        <SNSPanel />
        <div className="project-topic">
          <div className="container">
            <div className="topic inner-container">
              <div className="title">
                <h1 className="type-heading -en -h2">
                  <span>{_w.heading}&nbsp;</span>
                  <span className="highlight">{_w.heading_color}</span>
                </h1>
              </div>
              <div className="illustration">
                <img src="/images/project-heading.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="project-list">
          <div className="container">
            <div className="filter inner-container">
              <button className={`text-button ${currentCategory === null ? '-active' : ''}`}
                onClick={() => handleCategoryClick(null)}><span className="type-text -en -lg">All</span></button>
              {
                category && category.map((item, i) =>
                  <button key={i}
                    className={`text-button ${currentCategory === item.slug ? '-active' : ''}`}
                    onClick={() => handleCategoryClick(item.slug)}
                  ><span className="type-text -en -lg">{item.name}</span></button>
                )
              }
            </div>
            <div className="project-grid row">
              {
                project && project.map((item, i) =>
                  <div className="item col-xl-4 col-lg-6 col-md-6" key={item.slug}>
                    <ProjectCard photo={`/${item.photo}`}
                      project={item.title}
                      category={item.category.name}
                      clients={item.client}
                      link={`/project/${item.slug}`} />
                  </div>
                )
              }
              {
                project && project.length === 0 && loadingAnimation &&
                <div className="project-empty type-heading -ch -h1">{_w.loading}</div>
              }
              {
                project && project.length === 0 && !loadingAnimation &&
                <div className="project-empty type-heading -ch -h1">{_w.empty}</div>
              }
            </div>
          </div>
        </div>
        <div className="auto-load" ref={autoload} data-index="1">
          {
            loadingAnimation &&
            <div className="loading-dot">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectList;
